import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebaseConfig';
import Button from './Button';
import EditDotsIcon from '../assets/images/edit-dots.svg';
import { klasaStatusu } from '../lib/paymentStatus';
import EditInstallmentModal from './EditInstallmentModal';


const EditableInstallmentsTable = ({ investmentId, flatId, flatCode, className, topContent }) => {
  const [installments, setInstallments] = useState([]);
  const [accountNumber, setAccountNumber] = useState('');
  useEffect(() => {
    const fetchInstallments = async () => {
      if (investmentId && flatId) {
        try {
          const installmentsCollection = collection(
            firestore,
            `investments/${investmentId}/flats/${flatId}/payments`
          );
          const snapshot = await getDocs(installmentsCollection);
          const data = snapshot.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }));

          // Ten ekran TYLKO pokazuje. Oznaczanie rat "Po terminie" robi nocny
          // przelicz_statusy_lokali.py, a nie render tabeli.
          //
          // Bylo tu odwrotnie: samo otwarcie lokalu zapisywalo do Firestore
          // "Po terminie" dla kazdej wymagalnej raty po terminie. Historia
          // platnosci zalezala wiec od tego, kto i kiedy wszedl na ekran.
          // 10.09.2026 wisialo tak 18 rat z Puszczykowa na 3 902 748,51 zl,
          // najstarsza z terminem 29 lipca - szesc tygodni i nikt nie zajrzal.
          setInstallments(data);

          // Fetch flat to get account_number
          const flatDocRef = doc(firestore, `investments/${investmentId}/flats/${flatId}`);
          const flatDocSnap = await getDoc(flatDocRef);

          if (flatDocSnap.exists()) {
            const flatData = flatDocSnap.data();
            setAccountNumber(flatData.account_number || 'Brak rachunku');
          }
        } catch (error) {
          console.error('Error fetching installments:', error);
        }
      }
    };

    fetchInstallments();
  }, [investmentId, flatId]);

  const basicTdClasses = 'py-[15px] px-[15px] text-left';

  const openModal = (row) => {
    setSelectedInstallment(row);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    const refetchInstallments = async () => {
      if (investmentId && flatId) {
        try {
          const installmentsCollection = collection(
            firestore,
            `investments/${investmentId}/flats/${flatId}/payments`
          );
          const snapshot = await getDocs(installmentsCollection);
          const data = snapshot.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }));

          // Jak wyzej: render niczego nie zapisuje.
          setInstallments(data);
        } catch (error) {
          console.error('Error fetching installments:', error);
        }
      }
    };

    refetchInstallments();
    setIsModalOpen(false);
    setSelectedInstallment(null);
  };

    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
  const [selectedInstallment, setSelectedInstallment] = useState(null);  // Store selected row


const calculateSummary = () => {
  const summary = {
    percentage: 0,
    amount: 0,
    paid: 0,
    left_amount: 0,
    paid_out_amount: 0,
  };

  installments.forEach((row) => {
    summary.percentage += parseFloat(row.percentage || 0);
    summary.amount += parseFloat(row.amount || 0);
    summary.paid += parseFloat(row.paidAmount || 0);
    summary.left_amount += parseFloat(row.remainingAmount || 0);
    summary.paid_out_amount += parseFloat(row.withdrawnAmount || 0);
  });

  return {
    percentage: summary.percentage.toFixed(2) + '%',
    amount: (summary.amount || 0).toLocaleString() + ' zł',
    paid: (summary.paid || 0).toLocaleString() + ' zł',
    left_amount: (summary.left_amount || 0).toLocaleString() + ' zł',
    paid_out_amount: (summary.paid_out_amount || 0).toLocaleString() + ' zł',
  };
};

const summary = calculateSummary();

  return (
     <div
      className={`${className} bg-white rounded-[6px] border border-[var(--bright-gray)] text-[var(--electric-blue)] overflow-x-auto w-[calc(100vw-380px)] max-1024:w-[calc(100vw-255px)] max-768:w-[calc(100vw-55px)]`}
    >
      <div className="sticky left-0 py-[20px] px-[20px] border-b border-[var(--bright-gray)]">
        {topContent}
      </div>    
      <table className="w-full whitespace-nowrap relative">
        <thead>
          <tr className="bg-[var(--lotion)] border-b border-[var(--bright-gray)]">
            <th className={`${basicTdClasses} font-medium`}>Lp.</th>
            <th className={`${basicTdClasses} font-medium`}>Termin z AN</th>
            <th className={`${basicTdClasses} font-medium`}>Termin płatności</th>
            <th className={`${basicTdClasses} font-medium`}>% Ceny brutto</th>
            <th className={`${basicTdClasses} font-medium`}>Kwota</th>
            <th className={`${basicTdClasses} font-medium`}>Status</th>
            <th className={`${basicTdClasses} font-medium`}>Data zapłaty</th>
            <th className={`${basicTdClasses} font-medium`}>Zapłacono</th>
            <th className={`${basicTdClasses} font-medium`}>Pozostało</th>
            <th className={`${basicTdClasses} font-medium`}>Wypłacono</th>
            <th className={`${basicTdClasses} font-medium`}>Wypłacono dnia</th>
          </tr>
        </thead>
        <tbody>
          {installments.sort((a, b) => a.paymentNumber - b.paymentNumber).map((row, rowIndex) => (
            <tr key={row.id}>
            <td className={basicTdClasses}>{rowIndex + 1}</td> {/* Lp. value */}
                <td className={`${basicTdClasses}`} >

            {row['dueDate'] || '-'}

                </td>
                <td className={`${basicTdClasses}`} >

            {row['paymentDueDate'] || '-'}

                </td>
               <td className={`${basicTdClasses}`} >
            {(row['percentage'] || 0).toFixed(2)}%
                </td>         
                <td className={`${basicTdClasses}`}>
            {(row['amount'] || 0).toLocaleString()}
         
                </td> 
<td className={`${basicTdClasses}`}>
    <span className={klasaStatusu(row['payment_status'])}>
      {row['payment_status']}
    </span>

</td>  
                <td className={`${basicTdClasses}`} >
            {row['payment_date'] ? (
              typeof row['payment_date'] === 'string'
                ? row['payment_date']
                : row['payment_date'].toDate?.().toLocaleDateString('pl-PL') || ''
            ) : ''}
                </td>   
                <td className={`${basicTdClasses}`}>

            {(row['paidAmount'] || 0).toLocaleString()}
      
                </td>  
                <td className={`${basicTdClasses}`}>
         
            {(row['remainingAmount'] || 0).toLocaleString()}
          
                </td>                 
                <td className={`${basicTdClasses}`}>

            {(row['withdrawnAmount'] || 0).toLocaleString()}

                </td>  
                <td className={`${basicTdClasses}`}>
            {row['dateField']}
        
                </td>                                                                                                  
              <td className="py-[15px] px-[15px]">

                  <Button
                    variant="flat"
                    onClick={() => openModal(row)}
                  >
                    <img src={EditDotsIcon} alt="Edytuj" />
                  </Button>
              
              </td>
            </tr>
          ))}
            {/* Summary Row */}
  <tr className="bg-[#E6E6E7] font-semibold">
    <td className={`${basicTdClasses}`}>Razem</td>
    <td >&nbsp;</td>
    <td >&nbsp;</td>
    <td className={`${basicTdClasses}`}>{summary.percentage}</td>
    <td className={`${basicTdClasses}`}>{summary.amount}</td>
    <td className={`${basicTdClasses}`} colSpan={2}></td>
    <td className={`${basicTdClasses}`}>{summary.paid}</td>
    <td className={`${basicTdClasses}`}>{summary.left_amount}</td>
    <td className={`${basicTdClasses}`}>{summary.paid_out_amount}</td>
    <td className={`${basicTdClasses}`} colSpan={2}></td>
  </tr>
  {/* Account Number Row */}
<tr>
  <td className={`${basicTdClasses} font-semibold`}>Rachunek bankowy:</td>
  <td className={`${basicTdClasses}`} colSpan={10}>{accountNumber}</td>
</tr>
        </tbody>
      </table>

            {selectedInstallment && (
        <EditInstallmentModal
          isOpen={isModalOpen}
          onClose={closeModal}
          investmentId={investmentId}
          flatId={flatId}
          installment={selectedInstallment}
          flatCode={flatCode}
        />
      )}
    </div>
  );
};

export default EditableInstallmentsTable;
